import { SalesIncentiveType } from "@utils/enums";

export const getTitle = (model: {
    name?: string;
    productTitle?: string;
    articleConfiguration?: {
        title?: string;
    } | null;
}) => {
    if (model.articleConfiguration) {
        return model.articleConfiguration.title || "";
    }

    return model.productTitle || model.name || "";
};

export const getFormattedCashBackValue = (
    promotions?: {
        promotionType?: SalesIncentiveType | null;
        promotionValue: number | null;
        promotionPercent?: number | null;
        promotionPercentage?: number | null;
    }[],
) => {
    const cb = promotions?.find(
        p => p.promotionType === SalesIncentiveType.Cashback,
    );

    if (cb?.promotionValue) {
        return `${cb.promotionValue}€`;
    }
    if (cb?.promotionPercent) {
        return `${cb.promotionPercent}%`;
    }
    if (cb?.promotionPercentage) {
        return `${cb.promotionPercentage}%`;
    }
};
